import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "@/views/public/home/HomePage.tsx";
import { PublicLayout } from "@/components/public/PublicLayout.tsx";

export const Route = createFileRoute("/")({
  component: PublicHomePage,
});

function PublicHomePage() {
  return (
    <PublicLayout>
      <HomePage />
    </PublicLayout>
  );
}
